import { useEffect, useState } from "react";
import { apiGet } from "../../legacy/services/apiClient";
import { resolveMediaUrl } from "../../utils/resolveMediaUrl";
import { asArray } from "../mobileUtils";
import { packageCards } from "../data/mobileFallbackData";
import MobileLayout from "../layouts/MobileLayout";

export default function MobilePackages() {
  const [items, setItems] = useState(packageCards);

  useEffect(() => {
    let active = true;
    apiGet("/api/packages?limit=8")
      .then((payload) => {
        const rows = asArray(payload);
        if (!active || !rows.length) return;
        setItems(rows.map((item) => ({
          title: item.title || item.name || "Holiday package",
          meta: item.duration_label || item.duration || item.subtitle || "Custom itinerary",
          image: resolveMediaUrl(item.cover_image || item.image_url || item.image || "") || "/landing/original/curated-card-1.jpg",
        })));
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return (
    <MobileLayout showFooter>
      <section className="hv-hero" style={{ minHeight: 430 }}>
        <img src="/landing/original/curated-side.png" alt="" loading="eager" />
        <div className="hv-hero-content" style={{ minHeight: 430 }}>
          <span className="hv-badge">HOLIDAY PACKAGES</span>
          <h1>Journeys planned around you</h1>
          <p>Luxury stays, private cars and local experiences bundled into relaxed itineraries.</p>
          <a className="hv-primary-btn" href="/custom-tour">Plan My Trip</a>
        </div>
      </section>
      <section className="hv-section">
        <div className="hv-section-head"><h2 className="hv-section-title">Package categories</h2></div>
        <div className="hv-tabs">
          {["Honeymoon", "Family", "Weekend", "Luxury", "Pilgrimage"].map((item) => <button className="hv-tab" type="button" key={item}>{item}</button>)}
        </div>
      </section>
      <div className="hv-list-stack">
        {items.map((item) => (
          <article className="hv-card hv-property-card" key={item.title}>
            <img src={item.image} alt={item.title} loading="lazy" />
            <div className="hv-property-body">
              <div className="hv-property-meta">Destination wise package</div>
              <h3 className="hv-property-title">{item.title}</h3>
              <div className="hv-muted-row">{item.meta}</div>
              <div className="hv-property-bottom"><span className="hv-price">Custom quote</span><a className="hv-primary-btn" href="/custom-tour" style={{ minHeight: 34 }}>Enquire</a></div>
            </div>
          </article>
        ))}
      </div>
    </MobileLayout>
  );
}
